const hostNameTOServerName: {
	[key: string]: {
		MainServerURL: string, LoginServiceURL: string,
		QuizServerURL: string, QuizAdminServerURL: string,
		StaticStorageApiURL: string,
		SocketServerURL: string, InviteLinkURL: string,
		NotificationServiceURL: string,
	} | undefined
} = {
	'tests.codequotient.com': {
		MainServerURL: 'https://course.codequotient.com',
		LoginServiceURL: 'https://login.codequotient.com',
		QuizServerURL: 'https://codequotient.com',
		QuizAdminServerURL: 'https://codequotient.com',
		SocketServerURL: 'https://codequotient.com',
		StaticStorageApiURL: 'https://static.test.codequotient.com',
		InviteLinkURL: 'https://codequotient.com',
		NotificationServiceURL: 'https://event.codequotient.com',

	},
	'tests.cqtestga.com': {
		MainServerURL: 'https://course.cqtestga.com',
		LoginServiceURL: 'https://login.cqtestga.com',
		QuizServerURL: 'https://cqtestga.com',
		QuizAdminServerURL: 'https://cqtestga.com',
		SocketServerURL: 'https://cqtestga.com',
		StaticStorageApiURL: 'https://static.cqtestga.com',
		InviteLinkURL: 'https://cqtestga.com',
		NotificationServiceURL: 'https://event.cqtestga.com',
	},
	'exam.testpad.chitkara.edu.in': {
		MainServerURL: 'https://course.testpad.chitkara.edu.in',
		LoginServiceURL: 'https://login.testpad.chitkara.edu.in',
		QuizServerURL: 'https://infra.assess.testpad.chitkara.edu.in',
		QuizAdminServerURL: 'https://admin.infra.assess.testpad.chitkara.edu.in',
		SocketServerURL: 'https://infra.assess.testpad.chitkara.edu.in',
		StaticStorageApiURL: 'https://static.assess.testpad.chitkara.edu.in',
		InviteLinkURL: 'https://assess.testpad.chitkara.edu.in',
		NotificationServiceURL: 'https://events.infra.assess.testpad.chitkara.edu.in',
	},
	'exam.testpad.chitkarauniversity.edu.in': {
		MainServerURL: 'https://course.testpad.chitkarauniversity.edu.in',
		LoginServiceURL: 'https://login.testpad.chitkarauniversity.edu.in',
		QuizServerURL: 'https://infra.assess.testpad.chitkarauniversity.edu.in',
		QuizAdminServerURL: 'https://admin.infra.assess.testpad.chitkarauniversity.edu.in',
		SocketServerURL: 'https://infra.assess.testpad.chitkarauniversity.edu.in',
		StaticStorageApiURL: 'https://static.assess.testpad.chitkarauniversity.edu.in',
		InviteLinkURL: 'https://assess.testpad.chitkarauniversity.edu.in',
		NotificationServiceURL: 'https://events.infra.assess.testpad.chitkarauniversity.edu.in',
	},
};

let config = hostNameTOServerName[window.location.hostname];

if (!config) {
	config = {
		MainServerURL: process.env.REACT_APP_MAIN_SERVER_URL as string,
		QuizServerURL: process.env.REACT_APP_QUIZ_SERVER_URL as string,
		QuizAdminServerURL: process.env.REACT_APP_QUIZ_ADMIN_SERVER_URL as string,
		SocketServerURL: process.env.REACT_APP_SOCKET_SERVER_URL as string,
		LoginServiceURL: process.env.REACT_APP_LOGIN_SERVER_URL as string,
		StaticStorageApiURL: process.env.REACT_APP_STATIC_STORAGE_API_URL as string,
		InviteLinkURL: process.env.REACT_APP_INVITE_LINK_URL as string,
		NotificationServiceURL: process.env.REACT_APP_NOTIFICATION_SERVICE_URL as string,
	};
}

export const APP_CONFIG: AppConfig = {
	MainServerURL: config.MainServerURL,
	QuizServerURL: config.QuizServerURL,
	QuizAdminServerURL: config.QuizAdminServerURL,
	SocketServerURL: config.SocketServerURL,
	NotificationServiceURL: config.NotificationServiceURL,
	LoginServiceURL: config.LoginServiceURL,
	StaticStorageApiURL: config.StaticStorageApiURL,
	InviteLinkURL: config.InviteLinkURL,
	CaptiaKey: process.env.REACT_APP_CAPTIA_KEY as string,
	isChitkara: (process.env.REACT_APP_Chitkara as string) === '1',
	LiveStreamPublicApiKey: (process.env.REACT_APP_JITSI_PUBLIC_API_KEY as string),
	ElectronScheme: ((process.env.REACT_APP_Chitkara as string) === '1') ? 'testpad-chitkara' : 'test-codequotient',
	EnableProctorNotation: (process.env.REACT_APP_ENABLED_PROCTOR_NOTATION === '1'),
	DisabledMultiScreenCheck: (process.env.REACT_APP_DISABLE_MULTISCREEN_CHECK === '1'),
};

export const isElectronApp: boolean = ('api' in window);

export const API_PATHS = {};

export * from './constants';
